export const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export const EMAIL_URL = process.env.REACT_APP_BACKEND_URL;
export const AUTHORITY = process.env.REACT_APP_AUTHORITY;

export const BASE_URL = window.location.protocol + '//' + window.location.host;
